export default __webpack_public_path__ + "static/media/erp.f9c7f793.png";